import { createPerimeter } from 'vue-kindergarten';
import { isRole } from '../utilities/roleUtilities';

export const ProductsPerimeter = createPerimeter({
    purpose: 'product',

    can: {
        read () {
            return isRole.admin(this.child)
                || isRole.shop_owner(this.child)
                || isRole.key_account(this.child);
        },
        // only admin can see admin options
        viewAdminOptions () {
            return isRole.admin(this.child);
        },
        add () {
            return isRole.admin(this.child)
                || isRole.shop_owner(this.child)
                || isRole.key_account(this.child);
        },

        // only admin can edit product
        update () {
            return isRole.admin(this.child)
                || isRole.shop_owner(this.child)
                || isRole.key_account(this.child);
        },

        // if user can update articles then she can also destroy them
        destroy () {
            return this.isAllowed('update');
        }
    }
});
